import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';

import { UPDATE_INTERNAL_USER_PERMISSION, UpdateInternalUserPermissionType } from '../../../api/permission';
import { UserPermissionType } from '../../../types/permission';
import SettingsItemPermission from '../../SettingsItemPermission';

type InternalUserPermissionProps = {
	disabled: boolean;
	permission: UserPermissionType;
	onPermissionChanged: () => void;
};

const InternalUserPermission = ({
	disabled,
	permission: { id, inheritedValue, name, value: initialValue },
	onPermissionChanged,
}: InternalUserPermissionProps) => {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const [value, setValue] = useState(initialValue);

	const [updatePermission, { loading }] = useMutation<UpdateInternalUserPermissionType>(
		UPDATE_INTERNAL_USER_PERMISSION,
		{
			onCompleted: (data) => {
				const { updateInternalUserPermission } = data ?? {};
				// eslint-disable-next-line @typescript-eslint/naming-convention
				const { value: updatedValue } = updateInternalUserPermission ?? {};

				setValue(updatedValue);
				onPermissionChanged();
			},
		},
	);

	const handlePermissionUpdate = useCallback(
		(newValue?: boolean) => {
			updatePermission({
				variables: {
					updateInternalUserPermissionInput: { id, value: newValue === undefined ? null : newValue },
				},
			}).catch((e) => {
				throw e;
			});
		},
		[updatePermission, id],
	);

	useEffect(() => setValue(initialValue), [initialValue]);

	return (
		<SettingsItemPermission
			disabled={disabled}
			inheritedValue={inheritedValue}
			label={name}
			loading={loading}
			onChange={handlePermissionUpdate}
			value={value}
		/>
	);
};

export default InternalUserPermission;
